import React, { FC, memo, useMemo } from 'react';
import { useTranslation } from 'src/app/common/hooks/translation.hook';

import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import styles from './company-assisted-lead.module.css';
import { useCompanyAssistedLead } from './company-assisted-lead.hook';
import { InsightSectionComponent } from '../../../components/insight-section/insight-section.component';

type ComponentProps = ParamsProps & {
  // agent-code string, split by comma,
  // example: "00010001" or "00010001,00010002,00010003"
  agentCode?: string;
};

export const CompanyAssistedLeadComponent: React.FC<ComponentProps> = memo((props: ComponentProps) => {
  // i18n
  const { t } = useTranslation();

  // custom-hook
  const { loading, data, tooltip, handlePress } = useCompanyAssistedLead({
    agentCode: props.agentCode,
  });

  return (
    <InsightSectionComponent onPress={handlePress} title={t('company_assisted_lead')} data={data} tooltip={tooltip} />
  );
});
